"use client";
import React, { useState } from 'react'
import axios from 'axios';
import axiosInstance from '@/lib/axiosInstance';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

type ErrorObject = {
    [key: string]: string;
};


interface propsTypes {
    // isVerification: boolean,
    // setIsVerification: React.Dispatch<React.SetStateAction<boolean>>;
    // setCurrentComponent: string;
    setCurrentComponent: React.Dispatch<React.SetStateAction<string>>;
    setVerificationUserId: React.Dispatch<React.SetStateAction<number | null>>;
}

export default function SignUp({ setCurrentComponent, setVerificationUserId }: propsTypes) {


    const [errors, setErrors] = useState<ErrorObject>({});
    const [success, setSuccess] = useState<string | null>(null);
    const [activationLink, setActivationLink] = useState<string | null>(null);
    const [activationLinkMessage, setActivationLinkMessage] = useState<string | null>(null);
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);



    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        hostUrl: '',
        sin:'',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
    // Handle form submission with proper typing
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // Handle form submission logic here
        setIsSubmit(true)
        try {
            // Get the protocol, hostname, and port from the window object
            const protocol = window.location.protocol; // e.g., 'http:' or 'https:'
            const hostname = window.location.hostname; // e.g., 'localhost'
            const port = window.location.port; // e.g., '3000'
            // Combine them into the full URL
            const fullUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
            formData.hostUrl = fullUrl;

            const response = await axiosInstance.post('api/users/signup',
                formData,
            );

            // setActivationLinkMessage(response?.data?.data?.message)
            // setActivationLink(domain + '/account-verification/' + response?.data?.data?.activationLink)


            setCurrentComponent('otpverification');
            setVerificationUserId(response?.data?.data.id);

            // verification
            // router.push('/verification')       

        } catch (error) {
            if (axios.isAxiosError(error)) {
                // validation error 
                let errorObject: ErrorObject = {};
                if (error?.response?.status === 403) {
                    let errorArray = error?.response?.data?.error;
                    // Convert the array of objects to a single object
                    if (Array.isArray(errorArray)) {
                        errorObject = errorArray.reduce((acc: any, cur: any) => ({ ...acc, ...cur }), {});
                    } else if (typeof error.response.data === 'object')
                        errorObject = error.response.data;
                    else
                        errorObject = { general: error.response.data };
                }
                setErrors(errorObject);
            }
        } finally {
            setIsSubmit(false)
        }
    };

    return (
        <div className="container border md:mt-14 rounded-md md:pt-10 pb-14">
            <h2 className="text-3xl font-playfair mt-5">Sign up</h2>
            <hr className="my-3" />
            <form onSubmit={handleSubmit}>
                <div className="grid md:grid-cols-2 py-5 gap-x-5 gap-y-4">
                    <div>
                        <label htmlFor="fName">
                            First Name:
                        </label>
                        <input className="border rounded-sm py-2 px-2 outline-none w-full block"
                            type="text"
                            name="firstName"
                            id="fName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                        {errors?.firstName && <p className='text-red-500'>{errors.firstName}</p>}

                    </div>
                    <div>
                        <label htmlFor="lName">
                            Last Name:
                        </label>
                        <input className="border rounded-sm py-2 px-2 outline-none w-full block"
                            type="text"
                            name="lastName"
                            id="lName"
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                        {errors?.lastName && <p className='text-red-500'>{errors.lastName}</p>}
                    </div>
                    <div>
                        <label htmlFor="phone">
                            Phone:
                        </label>
                        <input className="border rounded-sm py-2 px-2 outline-none w-full block"
                            type="text"
                            name="phone"
                            id="phone"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                        {errors?.phone && <p className='text-red-500'>{errors.phone}</p>}
                    </div>
                    <div>
                        <label htmlFor="email">
                            Email:
                        </label>
                        <input className="border rounded-sm py-2 px-2 outline-none w-full block"
                            type="text"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange} />
                        {errors?.email && <p className='text-red-500'>{errors.email}</p>}
                    </div>
                    <div>
                        <label htmlFor="password">
                            Create Password:
                        </label>
                        <div className="relative">
                            <input className="border rounded-sm py-2 px-2 pr-10 outline-none w-full block"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword((prev) => !prev)}
                                className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors?.password && <p className='text-red-500'>{errors.password}</p>}
                    </div>
                    <div>
                        <label htmlFor="confirmPassword">
                            Confirm Password:
                        </label>
                        <div className="relative">
                            <input className="border rounded-sm py-2 px-2 pr-10 outline-none w-full block"
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                id="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                                aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors?.confirmPassword && <p className='text-red-500'>{errors.confirmPassword}</p>}
                    </div>
                </div>


                {/* {activationLinkMessage && <p className='text-red-500'>{activationLinkMessage}</p>}

                <a target='_blank' href='http://localhost:3001/account-verification?token=e03a1287fa6fbdaada539059479815d8d2b70d046c3de167a0e8e0b90da04ad9&email=activation@gmail.com'> Active</a> */}
                <div>
                    <button className="capitalize mt-4 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] text-white tracking-wider" disabled={isSubmit}>
                        {isSubmit ? (
                            <div className="flex items-center justify-center">
                                <svg
                                    className="animate-spin h-5 w-5 mr-2 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    />
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 0 1 8-8v2a6 6 0 0 0-6 6h-2z"
                                    />
                                </svg>
                                {`Sign up`}
                            </div>
                        ) : 'Sign up'}
                    </button>
                </div>
            </form>
        </div>
    )


}


